import React, {Suspense, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import LoadingPage from "../../pages/loading";
import styles from "./index.module.scss";
import Navbar from "../navbar";
import HhxFooter from "../footer";

const WithoutHeaderWithoutFooter = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [selectedKeys, setSelectedKeys] = useState([])
    const menuItem = [
        {
            label: '首页',
            key: '/pages/index',
        },
        // {
        //     label: '成熟产品',
        //     key: '/pages/product',
        // },
        {
            label: '关于我们',
            key: '/pages/about',
        },
    ]

    useEffect(() => {
        setSelectedKeys([location.pathname])
    }, [location.pathname]);

    const handleNavBarClick = (key) => navigate(key);

    return (
        <div className={styles["layout-wrap"]}>
            <Suspense fallback={<LoadingPage height="100vh"/>}>
                <Navbar items={menuItem} selectedKeys={selectedKeys} onClick={handleNavBarClick}/>
                <Outlet/>
                <HhxFooter/>
            </Suspense>
        </div>
    );
};

export default WithoutHeaderWithoutFooter;
